<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2r"><a id="page_vii"><span class="caslona">A C K N O W L E D G M E N T S</span></a></h2><a id="page_vii">
<p class="noindent"><span class="NewAsterLTStd">I am deeply grateful to the many people who have made this book possible:</span></p>
<p class="indent"><span class="NewAsterLTStd">My editor, Laurie Chittenden, for opening her heart to this story and helping to make it even better; and my agent, Maria Massie, for her help and advice.</span></p>
<p class="indent"><span class="NewAsterLTStd">The members of QuiltNet, for their friendship and generosity.</span></p>
<p class="indent"><span class="NewAsterLTStd">My teachers, especially Percival Everett and James Walton, who told me I could do this.</span></p>
<p class="indent"><span class="NewAsterLTStd">The members of the Internet Writing Workshop, especially Lani Kraus, list owner, who supervises a wonderful forum for aspiring writers; Dave Swinford, administrator of the novels list and one of the nicest people on the net; Jody Ewing, for her kindness; and Candace Byers, Warren Richardson, and Lesli Richardson for their critiques.</span></p>
<p class="indent"><span class="NewAsterLTStd">My friend Christine Johnson, who read every chapter and never failed to encourage me when I needed it most.</span></p>
<p class="indent"><span class="NewAsterLTStd">Geraldine, Nic, and Heather Neidenbach; Virginia and Edward Riechman; and Leonard and Marlene Chiaverini, for their love and support.</span></p>
</a><p class="indent"><a id="page_vii"><span class="NewAsterLTStd">And most of all, to my husband, Marty, for everything.</span></a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?00d0b7b4